export default __webpack_public_path__ + "static/media/NoDatasourceImg.57296368.png";